import { useNotification } from "../context/NotificationContext";
import { ShortfyEvent } from "../types/event.types";

const useEventSearch = (
  setSearchResults: React.Dispatch<
    React.SetStateAction<ShortfyEvent[] | null>
  >,
  allEvents: ShortfyEvent[],
  resetPagination: () => void,
) => {
  const { setNotification } = useNotification();

  const handleSearch = (query: string) => {
    const trimmedQuery = query.trim().toLowerCase();

    if (!trimmedQuery) {
      setSearchResults(null);
      resetPagination();
      return;
    }

    try {
      const results = allEvents.filter((event) =>
        event.eventName.toLowerCase().includes(trimmedQuery) ||
        event.location.toLowerCase().includes(trimmedQuery) ||
        event.description?.toLowerCase().includes(trimmedQuery) ||
        event.eventId.toLowerCase().includes(trimmedQuery)
      );

      setSearchResults(results);
      resetPagination();
    } catch (error: any) {
      setNotification({
        type: "error",
        message: error.message || "Sorry! Something went wrong.",
      });
    }
  };

  return { handleSearch };
};

export default useEventSearch;
